<template>
  <div class="story-container">
  <!-- 新增灰色小字 -->
  <div class="story-header-text">
    <p>contact: xu_neu@163.com</p>
  </div>
    <h2 class="story-title">故事结尾</h2>
    <!-- <p v-if="loading" class="loading-text">加载中...</p>
    <p v-else-if="error" class="error-text">{{ error }}</p>
    <p v-else class="story-text">{{ storyContent }}</p> -->
    <p v-if="loading" class="loading-text">加载中...</p>
    <p v-else-if="error" class="error-text">{{ error }}</p>
    <p v-else-if="storyContent" class="story-text">{{ storyContent }}</p>
    <p v-else class="no-story-text">暂无故事内容</p>
    <div class="return-button-container">
      <button 
        @click="goBackToStart" 
        class="return-button"
        :disabled="loading"
      >
        开始新的故事
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      error: null
    };
  },
  computed: {
    storyContent() {
      return this.$store.state.story?.current_story || '暂无故事内容';
    }
  },
  // async created() {
  //   if (this.$route.query.isGeneratingEnd) {
  //     // 如果是通过交互逻辑跳转的，直接从 Vuex 状态中获取数据
  //     console.log('Loading data from Vuex store');
  //     return;
  //   }
  //   // 如果是直接访问结尾页面，调用 fetchStory 获取数据
  //   await this.loadStory();
  // },
  async created() {
  if (this.$route.query.isGeneratingEnd) {
    console.log('Loading data from Vuex store');
    // 检查Vuex是否存在数据，存在则关闭加载状态
    if (this.storyContent !== '暂无故事内容') {
      this.loading = false;
    }
    return;
  }
  // 直接访问页面时调用接口
  await this.loadStory();
},
  activated() {
    console.log('activate 调用loadstory'); // 添加日志
    this.loadStory();
  },
  watch: {
    '$route'(to) {
      if (to.path === '/story-end') {
        console.log('watch 调用loadstory'); // 添加日志
        this.loadStory();
      }
    }
  },
  methods: {
    async loadStory() {
      console.log('开始loadstory'); 
      try {
        this.loading = true;
        this.error = null;
        await this.$store.dispatch('fetchStory');
        console.log('结束调用fetchStory'); 
        // 如果数据仍未更新，强制清除缓存
        if (!this.storyContent) {
          this.$store.commit('CLEAR_STORY');
        }
      } catch (err) {
        console.error('数据加载失败:', err);
        this.error = '无法加载故事内容，请稍后重试';
      } finally {
        this.loading = false;
      }
    },
    goBackToStart() {
      // 清除旧数据确保下次加载最新内容
      this.$store.commit('CLEAR_STORY');
      this.$router.push('/');
    }
  }
};
</script>

<style scoped>
/* 新增样式 */
.story-header-text {
  color: #e2dede;
  font-size: 0.9rem;
  line-height: 1.4;
  margin-bottom: 1.5rem;
  border-bottom: 1px solid #eee;
  padding-bottom: 1rem;
}
.story-header-text p {
  margin: 0;
}
/* 保持原有样式，新增以下内容 */
.loading-text {
  color: #666;
  font-style: italic;
}

.error-text {
  color: #ff4757;
  font-weight: bold;
}

.return-button:disabled {
  background-color: #a4b0be;
  cursor: not-allowed;
  opacity: 0.7;
}

.story-container {
    max-width: 760px;
    margin: 0 auto;
    padding: 2rem;
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  }
  
  .story-title {
    font-size: 1.6rem;
    color: #2d3436;
    font-weight: 500;
    line-height: 1.4;
    margin-bottom: 1.5rem;
    text-align: left;
    border-left: 4px solid #6c5ce7;
    padding-left: 1rem;
  }
  
  .story-text {
    font-size: 1.1rem;
    color: #333;
    line-height: 1.6;
    text-align: left;
  }
  
  .return-button-container {
    margin-top: 2rem;
    text-align: center;
  }
  
  .return-button {
    background-color: #6c5ce7;
    color: white;
    padding: 1rem 2rem;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 1.1rem;
    transition: background-color 0.3s ease, transform 0.2s ease;
  }
  
  .return-button:hover {
    background-color: #5a47d2;
  }
  
  .return-button:active {
    transform: scale(0.98);
  }
  </style>